import React, { useMemo } from "react";
import ModalComponent from "../../../Modals";
import { useMediaQuery, useTheme, Typography, Box, IconButton } from "@mui/material";
import { SectionsConfigContainer } from "./styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Invitations, TEMPLATES } from "../../../../store/services/invitations/dto/invitations.dto";

interface SectionsConfigProps {
	onClose: () => void;
	managedInvitation: Invitations;
	handleUpdate: (data: Partial<Invitations>) => void;
}
interface ISecton {
	id: number;
	name: string;
	label: string;
	hidden: boolean;
}

const SectionsConfig = ({ onClose, managedInvitation, handleUpdate }: SectionsConfigProps) => {
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const sectionsList = useMemo(() => {
		if (Object.keys(managedInvitation.fieldVisibility).length === 0) {
			return [];
		}
		const { gallery, location, loveStory, comments } = managedInvitation.fieldVisibility;
		const list = [
			{
				id: 2,
				name: "loveStory",
				label: "Love Story",
				hidden: !!loveStory?.hidden
			},
			{
				id: 3,
				name: "location",
				label: "Location",
				hidden: !!location?.hidden
			},
			{
				id: 4,
				name: "comments",
				label: "Comments",
				hidden: !!comments?.hidden
			},
			{
				id: 1,
				name: "gallery",
				label: "Gallery",
				hidden: !!gallery?.hidden
			}
		] as ISecton[];

		return list;
	}, [managedInvitation]);

	const handleUpdateSetting = (section: ISecton, cb?: () => void) => {
		const options: Partial<Invitations> = {
			fieldVisibility: {
				...managedInvitation.fieldVisibility,
				[section.name]: { hidden: !section.hidden }
			}
		};
		handleUpdate(options);
	};

	return (
		<ModalComponent open={true} handleCloseModal={onClose} width={isSmallerScreen ? "95%" : "450px"}>
			<Typography className={"title"}>Sections Config</Typography>
			<SectionsConfigContainer>
				{sectionsList.map((section, i) => (
					<Box
						className={"config"}
						key={section.id}
						onClick={() => handleUpdateSetting(section)}
						style={{ cursor: "pointer" }}
					>
						<Box className={"name"}>{section.label}</Box>
						<Box className={"visibility"}>
							<IconButton>{section.hidden ? <VisibilityOff /> : <Visibility />}</IconButton>
						</Box>
					</Box>
				))}
			</SectionsConfigContainer>
		</ModalComponent>
	);
};

export default SectionsConfig;
